import NewCampaign from '@/src/components/campaigns/NewCampaign';
import React from 'react';

export const NewCampaignPage: React.FC = () => {
  return <NewCampaign />;
};
